import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IGetLLMConfigDTO,
  IGetLLMConfigResponse,
  IUpdateLLMConfigDTO,
  IUpdateLLMConfigResponse,
} from '@/models/llmConfig.model';
import { IApiError } from '@/models/apiError.model';
import { formatApiError } from '@/utils';
import { LLMConfigAPI } from '@/api';
import { SLICE_NAME } from './models';

export const getLLMConfig = createAsyncThunk<
  IGetLLMConfigResponse,
  IGetLLMConfigDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getLLMConfig`,
  async (params) => {
    const response = await LLMConfigAPI.getLLMConfig(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateLLMConfig = createAsyncThunk<
  IUpdateLLMConfigResponse,
  IUpdateLLMConfigDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateLLMConfig`,
  async (data) => {
    const response = await LLMConfigAPI.updateLLMConfig(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
